// extracted by css-extract-rspack-plugin
export default {"pill":"l7zWN","alignRight":"yumH8","sortIcon":"rPjts"};